<template>
	<div class="sticky top-0 backdrop-blur-3xl z-40">
		<div class="mx-auto w-full md:w-lg lg:w-3xl xl:w-5xl 2xl:w-6xl px-4 py-3 md:px-5 md:py-4 flex flex-col lg:flex-row lg:items-end gap-3">
			<SecondaryButton :color="Color.Gray" class="md:hidden place-self-start" @click.stop="emit('toggleMenu')">
				<i class="fa-solid fa-bars"/>
			</SecondaryButton>
			<div class="grow flex flex-col items-start gap-1">
				<Link v-if="returnUrl" :href="returnUrl" class="text-sm text-true-aareii-500 hover:text-true-aareii-600 dark:hover:text-true-aareii-400">
					<i class="fa-solid fa-chevron-left mr-2"/>
					{{ trans(returnLabel ?? 'general.return') }}
				</Link>
				<p class="text-xl lg:text-4xl font-bold">{{ title }}</p>
				<div v-if="subtitle || $slots.default()[0].children.length as number > 0" class="w-full flex items-end gap-3">
					<p class="grow font-light lg:text-xl">{{ subtitle }}</p>
					<slot/>
				</div>
			</div>
		</div>
		<div class="h-px bg-linear-to-r from-gray-50 dark:from-gray-950 via-gray-200 dark:via-gray-800 to-gray-50 dark:to-gray-950"/>
	</div>
</template>
<script setup lang="ts">
import {Link} from '@inertiajs/vue3'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import {defineProps, defineEmits} from 'vue'
import SecondaryButton from '@/Components/UI/Buttons/SecondaryButton.vue'

defineProps<{
	title:string,
	subtitle?:string,
	returnUrl?:string,
	returnLabel?:string,
}>()

const emit = defineEmits([
	'toggleMenu',
])
</script>